import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/country/`,
    detail: (id) => `${BASE_URL}/api/v1/country/${id}/`,
};

export const countryLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const countryDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const countryUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const countryDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
